import React from "react";
import { X, CheckCircle } from "react-feather";
import GuardAvatar from "./GuardAvatar";

// "N / Required Guards Selected" + a manual-override flag for anything picked that wasn't
// RECOMMENDED - the operator can always override, this just makes that visible rather than
// silent, per the spec's explicit "Manual Override" callout. Styled to match the candidate
// cards above (same avatar + card-row language) rather than a plain list, since this is the
// screen's "you're about to commit to this" moment - it should look deliberate, not bolted on.
const SelectedGuardsPanel = ({ selected, requiredQty, onRemove, onConfirm, isConfirming }) => {
  if (selected.length === 0) return null;

  const isFull = selected.length >= requiredQty;

  return (
    <div className="card mt-3" style={{ borderTop: "3px solid #1E8449" }}>
      <div className="card-body">
        <div className="d-flex align-items-center justify-content-between mb-3">
          <h6 className="mb-0 d-flex align-items-center gap-2">
            <CheckCircle size={16} className={isFull ? "text-success" : "text-muted"} />
            Selected Guards for Deployment
          </h6>
          <span className={`badge ${isFull ? "badge-linesuccess" : "badge-linelight"}`}>
            {selected.length} / {requiredQty} Guard{requiredQty === 1 ? "" : "s"} Selected
          </span>
        </div>
        <div className="mb-3">
          {selected.map((c) => (
            <div key={c.employeeRecordGuid} className="guard-candidate-card is-selected">
              <GuardAvatar employeeRecordGuid={c.employeeRecordGuid} hasPhoto={c.hasPhoto} />
              <div className="guard-candidate-identity flex-grow-1">
                <div className="fw-semibold">
                  {c.empName} {c.empLastName}
                  {c.status !== "RECOMMENDED" && (
                    <span className="badge badge-linewarning ms-2">Manual Override</span>
                  )}
                </div>
                <div className="text-muted small">
                  {c.grade ? c.grade.charAt(0) + c.grade.slice(1).toLowerCase() + " grade" : "No grade on file"}
                  {c.status !== "RECOMMENDED" && " · Selected despite a lower recommendation"}
                </div>
              </div>
              <button type="button" className="btn btn-sm btn-icon" onClick={() => onRemove(c)} aria-label="Remove">
                <X size={16} />
              </button>
            </div>
          ))}
        </div>
        <button type="button" className="btn btn-primary" onClick={onConfirm} disabled={isConfirming}>
          {isConfirming ? "Confirming..." : "Confirm Selection"}
        </button>
      </div>
    </div>
  );
};

export default SelectedGuardsPanel;
